import { FC } from 'react';
import { Box, Typography, BoxProps } from '@mui/material';
import { useDateService } from 'framework/utils';
import moment from 'moment';
import { Badge } from '../mui-builder';

interface BirthdayInfoProps extends BoxProps {
  dateOfBirth: string | Date;
}

const BirthdayInfo: FC<BirthdayInfoProps> = ({ dateOfBirth, ...props }) => {
  const { getCurrentDate, getMomentDateObj, getDaysBetween, getMonthsBetween } = useDateService();

  const today = moment.utc(getCurrentDate().format('YYYY-MM-DD'));
  const birthDate = moment.utc(getMomentDateObj(dateOfBirth).format('YYYY-MM-DD'));

  const age = today.diff(birthDate, 'years');

  const nextBirthday = birthDate.clone().year(today.year());

  if (nextBirthday.isBefore(today)) {
    nextBirthday.add(1, 'year');
  }

  const daysUntilBirthday = getDaysBetween(nextBirthday, today);
  const monthsUntilBirthday = Math.abs(getMonthsBetween(nextBirthday, today) || 0);

  const shouldShowBirthdayChip = monthsUntilBirthday < 1;

  let birthdayText = '';

  if (daysUntilBirthday === 0) {
    birthdayText = 'Birthday today';
  } else {
    birthdayText = `Birthday in ${daysUntilBirthday} day${daysUntilBirthday !== 1 ? 's' : ''}`;
  }

  return (
    <Box display="flex" gap={1} {...props}>
      <Typography variant="body2">{`${age} years old`}</Typography>

      {shouldShowBirthdayChip && (
        <Box>
          <Badge
            color="default"
            sx={{
              fontSize: 10,
            }}
          >
            {birthdayText}
          </Badge>
        </Box>
      )}
    </Box>
  );
};

export default BirthdayInfo;
